import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import io from 'socket.io-client';
import './App.css';
import BeneficiaryDashboard from './components/BeneficiaryDashboard';
import Header from './components/Header';
import AlertSystem from './components/AlertSystem';

const socket = io(process.env.NODE_ENV === 'production' ? window.location.origin : 'http://localhost:8080');

function App() {
  const [alerts, setAlerts] = useState<any[]>([]);

  useEffect(() => {
    socket.on('new-alert', (alert) => {
      setAlerts(prev => [alert, ...prev].slice(0, 5)); // Keep only latest 5 alerts
    });

    socket.on('beneficiary-added', (beneficiary) => {
      // Handle beneficiary added notification
    });

    socket.on('verification-complete', (verification) => {
      // Handle verification complete notification
    });

    return () => {
      socket.off('new-alert');
      socket.off('beneficiary-added');
      socket.off('verification-complete');
    };
  }, []);

  const handleDismissAlert = (alertId: string) => {
    setAlerts(prev => prev.filter(alert => alert.id !== alertId));
  };

  const addAlert = (message: string, type: string = 'info') => {
    const alert = {
      id: Date.now().toString(),
      message,
      type,
      timestamp: new Date().toISOString()
    };
    setAlerts(prev => [alert, ...prev].slice(0, 5));
  };

  return (
    <div className="App">
      <Header />
      <motion.main
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="main-content"
      >
        <BeneficiaryDashboard socket={socket} onAlert={addAlert} />
        <AlertSystem alerts={alerts} onDismiss={handleDismissAlert} />
      </motion.main>
    </div>
  );
}

export default App;
